import type { ReactNode } from 'react'

import { ScrollArea } from '@/components/ui/scroll-area'
import { Separator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'

import { DomainInfoCard } from './domain-overview-domain-info-card.atom'
import { HostingCard } from './domain-overview-hosting-card.atom'
import { DomainOverviewMetrics } from './domain-overview-metrics.atom'
import { SeoCard } from './domain-overview-seo-card.atom'
import { SslCard } from './domain-overview-ssl-card.atom'
import { DomainOverviewTechnologies } from './domain-overview-technologies.atom'
import type { DomainOverviewData } from './split-view.interface'

export interface DomainOverviewContentProps {
  data: DomainOverviewData
  className?: string
}

export const DomainOverviewContent: React.FC<DomainOverviewContentProps> = ({
  data,
  className,
}): ReactNode => (
  <ScrollArea className={cn('domain-overview-content h-full', className)}>
    <div className="flex flex-col gap-4 p-4">
      <DomainInfoCard
        domain={data.domain}
        registrar={data.registrar}
        registeredAt={data.registeredAt}
        expiresAt={data.expiresAt}
      />
      <HostingCard
        ipAddress={data.ipAddress}
        hosting={data.hosting}
        nameServerList={data.nameServerList}
      />
      <SslCard sslIssuer={data.sslIssuer} sslExpiresAt={data.sslExpiresAt} />
      <Separator />
      <DomainOverviewMetrics metricList={data.metricList} />
      <Separator />
      <DomainOverviewTechnologies technologyList={data.technologyList} />
      <Separator />
      <SeoCard
        score={data.seo.score}
        title={data.seo.title}
        description={data.seo.description}
        keywords={data.seo.keywords}
      />
    </div>
  </ScrollArea>
)
